// extracted by mini-css-extract-plugin
export default {"melodyVideo":"hN-z","isFullWidth":"iN-z","landingPageVideo":"jN-z","play":"kN-z","iframeVideo":"lN-z","playHidden":"mN-z","fullwidth":"nN-z"};